

export default function Tag () {

    return(
    <div>
        <div className=" bg-[#64ffda]/10 m-auto text-[#64ffda] text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
            JavaScript
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        React
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        NextJs
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        HTML
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Css
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Tailwind Css
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        NodeJs
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Express
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        SQL
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Jest
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Supertest
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        React Testing Libary
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Cypress
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Prisma
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Framer Motion
        </div>
    </div>
    )
}